import {
  Globe2,
  LayoutDashboard,
  Layers,
  Clock,
  DollarSign,
  Calendar,
  type LucideIcon,
} from "lucide-react";

export type CopilotChip = {
  icon: LucideIcon;
  label: string;
  prompt: string;
};

/**
 * Shared chip dataset for the hero composer + the relocated chip grid
 * (Rev 25.5). Labels + prompts verbatim from
 * docs/NEXIRT_DESIGN/Home.html lines 565-600. Rev 25.4 reframed chip 6
 * to "with one of your engineers" per the team-terminology directive.
 *
 * Importers:
 *   - apps/web/src/components/CopilotComposer.tsx (listens to the
 *     `nexirt:copilot:chip-prefill` window event and pre-fills its
 *     textarea on dispatch — no longer renders chips inline as of 25.5).
 *   - apps/web/src/components/CopilotComposerChips.tsx (renders the
 *     grid/rail and dispatches the event on click).
 */
export const COPILOT_CHIPS: CopilotChip[] = [
  {
    icon: Globe2,
    label: "Premium marketing site",
    prompt: "Show me what you can build for a marketing site that loads under 1 second.",
  },
  {
    icon: LayoutDashboard,
    label: "Client portal + auth",
    prompt: "I need a multi-tenant client portal with auth, billing and audit logs.",
  },
  {
    icon: Layers,
    label: "Ops dashboard",
    prompt: "An operations dashboard the team will actually open twice a day.",
  },
  {
    icon: Clock,
    label: "Payroll system",
    prompt: "A payroll system for a multi-site service business with role-based access.",
  },
  {
    icon: DollarSign,
    label: "See pricing",
    prompt: "Show pricing tiers and what's included at each level.",
  },
  {
    icon: Calendar,
    label: "Book a call",
    prompt: "Book a 30-minute discovery call with one of your engineers.",
  },
];

/**
 * Window event used to pre-fill the composer's textarea from any chip
 * mount site. CopilotComposer listens on this; CopilotComposerChips
 * dispatches it on click. Detail.prompt is the full sentence.
 */
export const CHIP_PREFILL_EVENT = "nexirt:copilot:chip-prefill";

declare global {
  interface WindowEventMap {
    [CHIP_PREFILL_EVENT]: CustomEvent<{ prompt: string }>;
  }
}
